import { createFileRoute } from "@tanstack/react-router";

import { AnalyticsPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/analytics")({
  component: AnalyticsPage,
});
